import { TASK_TYPES, TASK_STATUSES, TASK_STATUSES_DESC } from '../constants';

const tasksFilters = [
  {
    name: 'type',
    label: 'taskType',
    type: 'select',
    whereOperator: '=',
    options: Object.keys(TASK_TYPES).map((k) => ({
      value: TASK_TYPES[k],
      label: `enums.taskTypes.${TASK_TYPES[k]}`,
    })),
  },
  {
    name: 'completed',
    label: 'completed',
    type: 'dateDay',
  },
  {
    name: 'status',
    label: 'status',
    type: 'select',
    whereOperator: '=',
    options: Object.keys(TASK_STATUSES).map((k) => ({
      value: TASK_STATUSES[k],
      label: `enums.taskStatuses.${TASK_STATUSES_DESC[TASK_STATUSES[k]]}`,
    })),
  },
];

export default tasksFilters;
